module.exports = __webpack_public_path__ + "img/icon-bi-star.5d5ba519.svg";